import React, {useEffect, useState} from 'react';
import AdminHeader from "../UI/AdminHeader";
import AdminFilters from "../UI/AdminFilters";
import AdminCharts from "../AdminChart/AdminChart";
import _axios from "../../../httpService";
import Loader from "../../Loader";
import TableView from "../TableView/TableView";

const AnalyseB = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [lateTasks, setLateTasks] = useState({column: [], data: []});
  const [programers, setProgramers] = useState({column: [], data: []});

  const [filterDataPart, setFilterDataPart] = useState("")
  const [dataTemp, setDataTemp] = useState([]);
  const [typeTemp, setTypeTemp] = useState([]);
  const [titleTemp, setTitleTemp] = useState([]);
  const [optionsTemp, setOptionsTemp] = useState([]);
  const [temp, setTemp] = useState("");
  const [sumOfData, setSumOfData] = useState([]);


  // useEffect(() => {
  //   setIsLoading(true);
  //   _axios.get(localStorage.getItem("apiUrl") + "/sadenReports/?"+props.part+"Filter="+ filterDataPart1
  //     +"&part2Filter="+ JSON.stringify({type:'all', year:1401, month:''})+"")
  //     .then(data => {
  //
  //     //   console.log(data.data)
  //     // setAdminData(data.data)
  //     // setIsLoading(false)
  //     //
  //     // for (let key in data) {
  //       // for (const key2 in data[key]) {
  //       dataTemp.push(data[key].data)
  //       typeTemp.push(data[key].type)
  //       titleTemp.push(data[key].title)
  //       optionsTemp.push(data[key].options)
  //       // }
  //     // }
  //   }
  //   )
  // })

  setTimeout(() => {
    setTemp("newTemp");
  }, 1000)

  useEffect(() => {
    setIsLoading(true);
    let url = "";
    if (props.filterType === "type1") {
      if (filterDataPart !== "0") {
        url = localStorage.getItem("apiUrl") + "/sadenReports/?part=" + props.part + "&filter=" + JSON.stringify({
          type: 'task',
          programmerId: filterDataPart
        }) + "";
      } else {
        url = localStorage.getItem("apiUrl") + "/sadenReports/?part=" + props.part + "&filter=" + JSON.stringify({
          type: 'all',
          programmerId: filterDataPart
        }) + "";
      }
    } else if (props.filterType === "type2") {
      if (filterDataPart === "") {
        url = localStorage.getItem("apiUrl") + "/sadenReports/?part=" + props.part + "&filter=" + JSON.stringify({
          type: 'all', year: filterDataPart.year, month: filterDataPart.month}) + ""
      } else {
        url = localStorage.getItem("apiUrl") + "/sadenReports/?part=" + props.part + "&filter=" + JSON.stringify({
          type: filterDataPart.type, year: filterDataPart.year, month: filterDataPart.month , "taskId":filterDataPart.taskId}) + ""
      }
    } else {
      url = localStorage.getItem("apiUrl") + "/sadenReports/?part=" + props.part;
    }
    _axios.get(url
      // +"&part2Filter="+ JSON.stringify({type:'all', year:1401, month:''})+""
    )
      .then(data => {
        data = data.data;

        if (props.part === "part3") {
          console.log("data.lateTasks")
          setLateTasks(data.lateTasks)
          console.log("data.programers")
          setProgramers(data.programers)
          // debugger
        } else {
          const localDataTemp = []
          const localTypeTemp = []
          const localTitleTemp = []
          const localOptionsTemp = []
          const localSumOfData = []
          for (let key in data) {
            // for (const key2 in data[key]) {
            localDataTemp.push(data[key].data)
            localTypeTemp.push(data[key].type)
            localTitleTemp.push(data[key].title)
            localOptionsTemp.push(data[key].options)
            localSumOfData.push(data[key].sum)
            // }
          }

          setDataTemp(localDataTemp)
          setTypeTemp(localTypeTemp);
          setTitleTemp(localTitleTemp)
          setOptionsTemp(localOptionsTemp)
          setIsLoading(false)
          setSumOfData(localSumOfData)
        }

      })

    console.log(dataTemp.length);
  }, [filterDataPart, temp]);


  if (props.part === "part3") {
    return (
      <>
        <div><TableView data={lateTasks} height={"39vh"}/></div>
        <div><TableView data={programers} height={"39vh"}/></div>
      </>
    )
  } else
    return (
      <div>
        <AdminHeader BgColor={props.BgColor}>
          {props.HeaderText}
        </AdminHeader>
        {<AdminFilters filterType={props.filterType} onFilter={setFilterDataPart}/>}
        {isLoading === true ? <Loader/> :
          <div className={"row"}>
            {
              dataTemp.map((v, i) =>
                <AdminCharts
                  key={i * 0.002}

                  type={typeTemp[i]}
                  title={titleTemp[i]}
                  options={optionsTemp[i]}
                  data={v}
                  className={props.className}
                  sum={sumOfData[i]}
                />
              )
            }
          </div>}
      </div>
    );
};

export default AnalyseB;
